import { Box, Typography } from '@mui/material'
import { FC } from 'react'
import SpeakersAndSupportStaff from '../../pages/Workflow/View/SpeakersAndSupportStaff'

export interface PageTitleProps {
  title: string
  iconPath: string
}

export const PageTitle: FC<PageTitleProps> = ({ title, iconPath }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
      <Box
        sx={{
          width: '40px',
          height: '40px',
          borderRadius: '8px',
          padding: '8px',
          background: 'rgba(0, 107, 215, 0.1)'
        }}
      >
        <Box component='img' src={iconPath} alt={title} />
      </Box>
      <Typography
        sx={{
          ml: '10px',
          fontSize: { lg: '32px', md: '28px', sm: '24px', xs: '24px' },
          fontWeight: '700',
          lineHeight: '120%'
        }}
      >
        {title}
      </Typography>
    </Box>
  )
}
